/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Justreleased1Inputs */

const id_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baru dirilis`)
};

const ms_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baru dikeluarkan`)
};

const da_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lige udgivet`)
};

const de_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade veröffentlicht`)
};

const en_us2_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just released`)
};

const es_es2_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recién lanzado`)
};

const es_mx2_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recién lanzado`)
};

const fil_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kakarelease lang`)
};

const fr_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vient de sortir`)
};

const it_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appena uscito`)
};

const hu_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most megjelent`)
};

const nl_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Net uitgebracht`)
};

const no_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettopp utgitt`)
};

const pl_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Właśnie wydane`)
};

const pt_br2_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recém-lançados`)
};

const pt_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acabado de lançar`)
};

const ro_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocmai lansat`)
};

const fi_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juuri julkaistu`)
};

const sv_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyss släppt`)
};

const vi_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vừa phát hành`)
};

const tr_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni çıktı`)
};

const cs_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Právě vydáno`)
};

const bg_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Току-що издадено`)
};

const ru_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Только что вышло`)
};

const uk_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щойно вийшли`)
};

const ar_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صدر للتو`)
};

const hi_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अभी रिलीज़ हुआ`)
};

const th_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เพิ่งวางจำหน่าย`)
};

const ja_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リリースされたばかり`)
};

const zh_cn2_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刚刚发布`)
};

const zh_hant1_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`剛剛發布`)
};

const ko_home_hero_justreleased1 = /** @type {(inputs: Home_Hero_Justreleased1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`방금 출시`)
};

/**
* | output |
* | --- |
* | "Just released" |
*
* @param {Home_Hero_Justreleased1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_hero_justreleased1 = /** @type {((inputs?: Home_Hero_Justreleased1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Justreleased1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_hero_justreleased1(inputs)
	if (locale === "ms") return ms_home_hero_justreleased1(inputs)
	if (locale === "da") return da_home_hero_justreleased1(inputs)
	if (locale === "de") return de_home_hero_justreleased1(inputs)
	if (locale === "en-US") return en_us2_home_hero_justreleased1(inputs)
	if (locale === "es-ES") return es_es2_home_hero_justreleased1(inputs)
	if (locale === "es-MX") return es_mx2_home_hero_justreleased1(inputs)
	if (locale === "fil") return fil_home_hero_justreleased1(inputs)
	if (locale === "fr") return fr_home_hero_justreleased1(inputs)
	if (locale === "it") return it_home_hero_justreleased1(inputs)
	if (locale === "hu") return hu_home_hero_justreleased1(inputs)
	if (locale === "nl") return nl_home_hero_justreleased1(inputs)
	if (locale === "no") return no_home_hero_justreleased1(inputs)
	if (locale === "pl") return pl_home_hero_justreleased1(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_justreleased1(inputs)
	if (locale === "pt") return pt_home_hero_justreleased1(inputs)
	if (locale === "ro") return ro_home_hero_justreleased1(inputs)
	if (locale === "fi") return fi_home_hero_justreleased1(inputs)
	if (locale === "sv") return sv_home_hero_justreleased1(inputs)
	if (locale === "vi") return vi_home_hero_justreleased1(inputs)
	if (locale === "tr") return tr_home_hero_justreleased1(inputs)
	if (locale === "cs") return cs_home_hero_justreleased1(inputs)
	if (locale === "bg") return bg_home_hero_justreleased1(inputs)
	if (locale === "ru") return ru_home_hero_justreleased1(inputs)
	if (locale === "uk") return uk_home_hero_justreleased1(inputs)
	if (locale === "ar") return ar_home_hero_justreleased1(inputs)
	if (locale === "hi") return hi_home_hero_justreleased1(inputs)
	if (locale === "th") return th_home_hero_justreleased1(inputs)
	if (locale === "ja") return ja_home_hero_justreleased1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_hero_justreleased1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_hero_justreleased1(inputs)
	return ko_home_hero_justreleased1(inputs)
});
export { home_hero_justreleased1 as "home.hero.justReleased" }